import { makeStyles } from "@material-ui/core/styles";

export const LoadingStyles = makeStyles(theme => ({
  loadingResultsComponent: {
    marginTop: "150px;",
    marginBottom: "150px;"
  }
}));
